<script>
export default {
    props: {
        separator: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Project invalid'
        },
        description: {
            type: String,
            default: 'This project as been created before the latest major update of the product configurator and can not be used anymore.'
        }
    },

    methods: {

        activateTooltips () {
            $( document ).ready(function() {
                setTimeout(function() {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 800);
            });
        },
    },

    mounted() {
        this.activateTooltips();
    }
}

</script>

<template>
    <span>
        <span v-if="separator === 'before'"> | </span>
        <span class="text-danger"><span v-if="title">{{ $t(title)}} </span><i class="fas fa-info-circle text-danger fa-sm" data-toggle="tooltip" :title="$t(description)"></i></span>
        <span v-if="separator === 'after'"> | </span>
    </span>

</template>

